exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".activityDetail{height:100%}.activityDetail .detail{margin-left:20px;padding-bottom:30px;overflow:hidden;font-family:\\\\5FAE\\8F6F\\96C5\\9ED1 Regular,\\\\5FAE\\8F6F\\96C5\\9ED1;font-weight:400;font-style:normal}.activityDetail .title{display:inline-block;width:180px;text-align:right}.activityIcon{position:relative;top:-70px}.activityItem{height:40px}.activityDetail .imgSpan{position:relative;top:-70px}.activityDetail .panel{height:80px}.activityDetail img{display:inline-block;width:150px;height:80px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-4cd9c365!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/activity/activityDetail.vue
// module id = 522
// module chunks = 0